module.exports = __webpack_public_path__ + "static/media/dlc_certificate.f9a14460.svg";